import { useEffect, useRef } from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export function SearchBar({ value, onChange, placeholder, autoFocus }: SearchBarProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) ref.current?.focus();
  }, [autoFocus]);

  return (
    <div className="search-bar">
      <span className="search-bar-icon" aria-hidden="true">
        ⌕
      </span>
      <input
        ref={ref}
        type="search"
        inputMode="search"
        className="search-bar-input"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder ?? 'Search name, group, code or reference'}
        aria-label="Search subjects"
      />
      {value && (
        <button type="button" className="search-bar-clear" onClick={() => onChange('')} aria-label="Clear search">
          ×
        </button>
      )}
    </div>
  );
}
